export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "editor_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editor Shortcut"])},
        "error_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This field"])},
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required"])}
      },
      "fr": {
        "editor_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raccourcis d'Éditeur"])},
        "error_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette valeur"])},
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obligatoire"])}
      }
    }
  })
}